module.exports = __webpack_public_path__ + "img/quotebubble.7aab7d22.png";